module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "browse-item"
  }, [_c('section', {
    staticClass: "avatar-container"
  }, [_c('avatar', {
    attrs: {
      "profile-data": _vm.details,
      "profile-type": "game",
      "size": "large",
      "show-xp-info": true
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "overview"
  }, [_c('span', {
    staticClass: "name"
  }, [_c('router-link', {
    attrs: {
      "to": '/Game/' + _vm.details.stringUrl
    }
  }, [_c('i', {
    staticClass: "fas fa-gamepad"
  }), _vm._v(" " + _vm._s(_vm.details.alias))])], 1), _vm._v(" "), _c('span', {
    staticClass: "platform"
  }, [_vm._v("Platform: " + _vm._s(_vm.details.platforms))]), _vm._v(" "), _c('span', {
    staticClass: "genre"
  }, [_vm._v("Genre: " + _vm._s(_vm.details.genres))]), _vm._v(" "), _c('span', {
    staticClass: "rated"
  }, [_vm._v("Rated " + _vm._s(_vm.details.rating))]), _vm._v(" "), _c('span', {
    staticClass: "created"
  }, [_vm._v("Created: " + _vm._s(_vm._f("formatDate")(_vm.details.created)))]), _vm._v(" "), (_vm.details.lookingForMembers) ? _c('span', {
    staticClass: "wants-to-collab"
  }, [_vm._v("Currently Recruiting Developers")]) : _vm._e(), _vm._v(" "), (_vm.details.lookingForMembers) ? _c('ul', {
    staticClass: "seeking-roles"
  }, [(_vm.details.seekingDesigners) ? _c('li', [_vm._v("Designers")]) : _vm._e(), _vm._v(" "), (_vm.details.seekingArtists) ? _c('li', [_vm._v("Artists")]) : _vm._e(), _vm._v(" "), (_vm.details.seekingProgrammers) ? _c('li', [_vm._v("Programmers")]) : _vm._e(), _vm._v(" "), (_vm.details.seekingWriters) ? _c('li', [_vm._v("Writers")]) : _vm._e(), _vm._v(" "), (_vm.details.seekingMusicians) ? _c('li', [_vm._v("Musicians")]) : _vm._e(), _vm._v(" "), (_vm.details.seekingSfxArtists) ? _c('li', [_vm._v("SFX Artists")]) : _vm._e(), _vm._v(" "), (_vm.details.seekingTesters) ? _c('li', [_vm._v("Testers")]) : _vm._e(), _vm._v(" "), (_vm.details.seekingProducers) ? _c('li', [_vm._v("Producers")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.details.skills.length > 0) ? _c('ul', {
    staticClass: "seeking-roles"
  }, _vm._l((_vm.details.skills), function(skill) {
    return _c('li', [_vm._v(_vm._s(_vm.skillList[skill].skill))])
  })) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "about"
  }, [_c('span', [_vm._v("Members")]), _vm._v(" "), _c('ul', {
    staticClass: "members"
  }, _vm._l((_vm.details.memberList), function(member) {
    return _c('li', [_c('avatar', {
      attrs: {
        "profile-data": member,
        "profile-type": "developer",
        "size": "small",
        "show-xp-info": true
      }
    })], 1)
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3e6866c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Browse/BrowsePageGameItem.vue
// module id = 859
// module chunks = 2